function setDocumentTitle(title: string) {
  const titleElement = window.document.querySelector("head title");
  if (titleElement) titleElement.innerHTML = title;
}

export default setDocumentTitle;
